import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { Subscription, firstValueFrom } from 'rxjs';
import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';
import { PageState } from 'src/app/core/models/page-state/page-state.model';
import { HydrationService } from 'src/app/core/services/login/hydration.service';
import {
  HydrationRoles,
  HydrationSources,
} from 'src/app/core/store/common/interfaces/hydration-status-store.interface';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-legacy-upgrade-navigator',
  templateUrl: './legacy-upgrade-navigator.component.html',
  styleUrls: ['./legacy-upgrade-navigator.component.scss'],
})
export class LegacyUpgradeNavigatorComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'large',
  };

  constructor(
    private httpClient: HttpClient,
    private hs: HydrationService,
  ) {}

  async ngOnInit() {
    await this.hs.HydrateOnboardingStore(
      HydrationRoles.onboardingProspectOrOnboardingClient,
      HydrationSources.legacyUpgrade,
    );
    const { apiUrl } = environment;
    const legacyUpgradeControllerSuffix =
      'Onboarding/Onboarding/legacyUpgrade/';
    let state = new PageState();
    const res = await firstValueFrom(
      this.httpClient.get<IApiResponse>(
        `${apiUrl}${legacyUpgradeControllerSuffix}legacy-upgrade-navigator`,
      ),
    );
    state = new PageState(res.data);

    await this.hs.HydrateOnboardingStore(
      HydrationRoles.onboardingProspectOrOnboardingClient,
      HydrationSources.legacyUpgrade,
    );
    return true;
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }
}
